import get from '@invitato/helpers/dist/getLocale';

export default {
  open: get('Buka via YouTube', 'Open via YouTube'),
  subtitleYoutube: get(
    'Siaran langsung pernikahan juga dapat disaksikan melalui YouTube, silakan klik tombol di bawah:', 
    'Live wedding Holy Matrimony can also be watched via the YouTube, please tap the button below:'),
};